module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst dataJSON = model.dataJSON || []\nconst fieldConfig = model.config ||{}\nconst disabled = model.disabled || fieldConfig.disabled\nconst additionalClasses = [];\nif(disabled) additionalClasses.push('disabled');\nconst startHourConfig = utils.simpleMerge({\nformat: {\nsuffix: ' h',\ndecimals: 1,\nmin: 0,\nmax: 24\n}\n}, (fieldConfig.fields || {}).startHour, {\nformat: {\nmax: fieldConfig.maxStartHour\n}\n})\nconst priceConfig = utils.simpleMerge({\nformat: {\nsuffix: ' €',\ndecimals: 2,\nmin: 0,\n},\nformatData: {\ndecimals: 10,\n}\n}, (fieldConfig.fields || {}).price || {})\nconst priceCommissionConfig = utils.simpleMerge({\nformat: {\nsuffix: ' €',\ndecimals: 2,\nmin: 0,\n},\nformatData: {\ndecimals: 2,\n}\n}, (fieldConfig.fields || {}).priceCommission || {})\nconst priceHourlyRateConfig = utils.simpleMerge({\nformat: {\nsuffix: ' €/h',\ndecimals: 2,\nmin: 0,\n},\nformatData: {\ndecimals: 10,\n}\n}, (fieldConfig.fields || {}).priceHourlyRateConfig || {})\nconst priceHourlyRateCommissionConfig = utils.simpleMerge({\nformat: {\nsuffix: ' €/h',\ndecimals: 2,\nmin: 0,\n},\nformatData: {\ndecimals: 2,\n}\n}, (fieldConfig.fields || {}).priceHourlyRateCommissionConfig || {})\n%><div class=\"<%- additionalClasses.join(' ') %>\" data-field-code=\"<%- model.fieldCode %>\"><%\nfor(const d in dataJSON){\nconst entry = dataJSON[d] || {}\nconst entryClasses = ['entry']\nlet startHourInnerTitleKey = 'form.fields.flatScale.startHour.innerTitle'\nif(config.hideMaxStartHourPriceField && entry.startHour >= config.maxStartHour){\nentryClasses.push('hidePriceField')\nentryClasses.push('hideDeleteButton')\nstartHourInnerTitleKey = 'form.fields.flatScale.maxStartHour.innerTitle'\n}\n%><div class=\"<%- entryClasses.join(' ') %>\" data-field-key=\"<%= d %>\"><%\n// startHour, price, priceCommission?\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled || !d, dataFLOAT: entry.startHour, fieldKey: d, fieldCode: 'startHour', additionalCSSClass: 'fieldOf_startHour', placeholder: storage.__('form.fields.flatScale.startHour.placeholder'), innerTitle: storage.__(startHourInnerTitleKey), config: startHourConfig }}) %><%\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled, dataFLOAT: entry.price, fieldCode: 'price', fieldKey: d, additionalCSSClass: 'fieldOf_price', placeholder: storage.__('form.fields.flatScale.price.placeholder'), innerTitle: storage.__('form.fields.flatScale.price.innerTitle'), config: priceConfig }}) %><%\nif(config.showCommission){\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled, dataFLOAT: entry.priceCommission, fieldCode: 'priceCommission', fieldKey: d, additionalCSSClass: 'fieldOf_priceCommission', placeholder: storage.__('form.fields.flatScale.price.placeholder'), innerTitle: storage.__('form.fields.flatScale.priceCommission.innerTitle'), config: priceCommissionConfig }}) %><%\n}\n// priceHourlyRate, priceHourlyRateCommission?\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled, dataFLOAT: entry.priceHourlyRate, fieldCode: 'priceHourlyRate', fieldKey: d, additionalCSSClass: 'fieldOf_priceHourlyRate', placeholder: storage.__('form.fields.flatScale.priceHourlyRate.placeholder'), innerTitle: storage.__('form.fields.flatScale.priceHourlyRate.innerTitle'), config: priceHourlyRateConfig }}) %><%\nif(config.showCommission){\n%><%- include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled, dataFLOAT: entry.priceHourlyRateCommission, fieldCode: 'priceHourlyRateCommission', fieldKey: d, additionalCSSClass: 'fieldOf_priceHourlyRateCommission', placeholder: storage.__('form.fields.flatScale.priceHourlyRateCommission.placeholder'), innerTitle: storage.__('form.fields.flatScale.priceHourlyRateCommission.innerTitle'), config: priceHourlyRateCommissionConfig }}) %><%\n}\n// controls\n%><div class=\"controls\"><%\nif(d > 0){\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: 'flatScaleEntry', symbolOnly: true, fieldConfig: { disabled }, inline: true, preventTabIndex: true } }) %><%\n}\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'flatScaleEntry', symbolOnly: true, fieldConfig: { disabled }, inline: true, preventTabIndex: true } }) %><%\n%></div><%\n%></div><%\n}\n%></div>"
  , __filename = "components/templates/core/form/fields/flatScale.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const dataJSON = model.dataJSON || []
const fieldConfig = model.config ||{}
const disabled = model.disabled || fieldConfig.disabled
const additionalClasses = [];
if(disabled) additionalClasses.push('disabled');
const startHourConfig = utils.simpleMerge({
format: {
suffix: ' h',
decimals: 1,
min: 0,
max: 24
}
}, (fieldConfig.fields || {}).startHour, {
format: {
max: fieldConfig.maxStartHour
}
})
const priceConfig = utils.simpleMerge({
format: {
suffix: ' €',
decimals: 2,
min: 0,
},
formatData: {
decimals: 10,
}
}, (fieldConfig.fields || {}).price || {})
const priceCommissionConfig = utils.simpleMerge({
format: {
suffix: ' €',
decimals: 2,
min: 0,
},
formatData: {
decimals: 2,
}
}, (fieldConfig.fields || {}).priceCommission || {})
const priceHourlyRateConfig = utils.simpleMerge({
format: {
suffix: ' €/h',
decimals: 2,
min: 0,
},
formatData: {
decimals: 10,
}
}, (fieldConfig.fields || {}).priceHourlyRateConfig || {})
const priceHourlyRateCommissionConfig = utils.simpleMerge({
format: {
suffix: ' €/h',
decimals: 2,
min: 0,
},
formatData: {
decimals: 2,
}
}, (fieldConfig.fields || {}).priceHourlyRateCommissionConfig || {})

    ; __line = 59
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\" data-field-code=\"")
    ; __append( model.fieldCode )
    ; __append("\">")
    ; 
for(const d in dataJSON){
const entry = dataJSON[d] || {}
const entryClasses = ['entry']
let startHourInnerTitleKey = 'form.fields.flatScale.startHour.innerTitle'
if(config.hideMaxStartHourPriceField && entry.startHour >= config.maxStartHour){
entryClasses.push('hidePriceField')
entryClasses.push('hideDeleteButton')
startHourInnerTitleKey = 'form.fields.flatScale.maxStartHour.innerTitle'
}

    ; __line = 69
    ; __append("<div class=\"")
    ; __append( entryClasses.join(' ') )
    ; __append("\" data-field-key=\"")
    ; __append(escapeFn( d ))
    ; __append("\">")
    ; 
// startHour, price, priceCommission?

    ; __line = 71
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled || !d, dataFLOAT: entry.startHour, fieldKey: d, fieldCode: 'startHour', additionalCSSClass: 'fieldOf_startHour', placeholder: storage.__('form.fields.flatScale.startHour.placeholder'), innerTitle: storage.__(startHourInnerTitleKey), config: startHourConfig }}) )
    ; 

    ; __line = 72
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled, dataFLOAT: entry.price, fieldCode: 'price', fieldKey: d, additionalCSSClass: 'fieldOf_price', placeholder: storage.__('form.fields.flatScale.price.placeholder'), innerTitle: storage.__('form.fields.flatScale.price.innerTitle'), config: priceConfig }}) )
    ; 
if(config.showCommission){

    ; __line = 74
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled, dataFLOAT: entry.priceCommission, fieldCode: 'priceCommission', fieldKey: d, additionalCSSClass: 'fieldOf_priceCommission', placeholder: storage.__('form.fields.flatScale.price.placeholder'), innerTitle: storage.__('form.fields.flatScale.priceCommission.innerTitle'), config: priceCommissionConfig }}) )
    ; 
}
// priceHourlyRate, priceHourlyRateCommission?

    ; __line = 77
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled, dataFLOAT: entry.priceHourlyRate, fieldCode: 'priceHourlyRate', fieldKey: d, additionalCSSClass: 'fieldOf_priceHourlyRate', placeholder: storage.__('form.fields.flatScale.priceHourlyRate.placeholder'), innerTitle: storage.__('form.fields.flatScale.priceHourlyRate.innerTitle'), config: priceHourlyRateConfig }}) )
    ; 
if(config.showCommission){

    ; __line = 79
    ; __append( include('../../../../base/form/fields/text', { model: { atom: { dataType: 'float' }, disabled: disabled, dataFLOAT: entry.priceHourlyRateCommission, fieldCode: 'priceHourlyRateCommission', fieldKey: d, additionalCSSClass: 'fieldOf_priceHourlyRateCommission', placeholder: storage.__('form.fields.flatScale.priceHourlyRateCommission.placeholder'), innerTitle: storage.__('form.fields.flatScale.priceHourlyRateCommission.innerTitle'), config: priceHourlyRateCommissionConfig }}) )
    ; 
}
// controls

    ; __line = 82
    ; __append("<div class=\"controls\">")
    ; 
if(d > 0){

    ; __line = 84
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'showInsert', context: 'flatScaleEntry', symbolOnly: true, fieldConfig: { disabled }, inline: true, preventTabIndex: true } }) )
    ; 
}

    ; __line = 86
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'delete', context: 'flatScaleEntry', symbolOnly: true, fieldConfig: { disabled }, inline: true, preventTabIndex: true } }) )
    ; 

    ; __line = 87
    ; __append("</div>")
    ; 

    ; __line = 88
    ; __append("</div>")
    ; 
}

    ; __line = 90
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/form/fields/flatScale.ejs

}